import { useEffect, useState } from 'react';

export type Route =
  | { page: 'landing' }
  | { page: 'table'; roomId: string }
  | { page: 'monitor'; path: string }
  | { page: 'monitorTable'; path: string; roomId: string };

export function parseRoute(pathname: string): Route {
  const m = /^\/r\/([A-Za-z0-9_-]+)$/.exec(pathname);
  if (m) return { page: 'table', roomId: m[1]! };
  // The secret monitor segment; only the server knows whether it is the real one.
  const mon = /^\/([A-Za-z0-9_-]{8,64})(?:\/r\/([A-Za-z0-9_-]+))?$/.exec(pathname);
  if (mon) return mon[2] ? { page: 'monitorTable', path: mon[1]!, roomId: mon[2] } : { page: 'monitor', path: mon[1]! };
  return { page: 'landing' };
}

export function navigate(path: string): void {
  window.history.pushState(null, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() => parseRoute(window.location.pathname));
  useEffect(() => {
    const onPop = (): void => setRoute(parseRoute(window.location.pathname));
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);
  return route;
}
